module.exports = __webpack_public_path__ + "img/图层 5.871cea67.png";